export default __webpack_public_path__ + "static/media/Continuous_gradient.99934cf8.png";